import { List, ListItem, Text } from '@chakra-ui/react';
import React from 'react';

import { FinleyValleyBankResponseTapeRow } from '@finley-technologies/valley-bank-utils';

import { LoanAccountSummaryLink } from '~/valleyBank/domains/LoanAccounts/hooks/LoanAccountContext';

type CollateralAccountLoanAccountNumbersProps = {
  receivables: FinleyValleyBankResponseTapeRow[];
};
export const CollateralAccountLoanAccountNumbers = ({
  receivables,
}: CollateralAccountLoanAccountNumbersProps) => {
  const loanAccountNumbersStr =
    receivables[0]?.receivableReponseTapeRow.baseFields
      .finley_assigned_to_loan_accounts;
  if (typeof loanAccountNumbersStr !== 'string') {
    return <Text>Unassigned</Text>;
  }
  const loanAccountNumbers = loanAccountNumbersStr.split(';');
  return (
    <List>
      {loanAccountNumbers.map((loanAccountNumber) => {
        return (
          <ListItem key={loanAccountNumber}>
            <LoanAccountSummaryLink loanAccountId={loanAccountNumber}>
              {loanAccountNumber}
            </LoanAccountSummaryLink>
          </ListItem>
        );
      })}
    </List>
  );
};
